import './Group.less';
import React, {useState, useEffect} from 'react';
import Icon from "../../../../components/icon/Icon";


export default function Group({children, name, title, defaultCollapsed = false}) {
    const [collapsed, setCollapsed] = useState(defaultCollapsed);

    return <div className={`group ${name}-group`}>
        <div
            className="group-heading"
            onClick={() => setCollapsed(!collapsed)}
        >
            <Icon name={collapsed ? 'plus' : 'minus'}/>
            <div className="title">{title}</div>
        </div>

        {
            collapsed ||
            <div className="group-body">
                {children}
            </div>
        }
    </div>;
}
